import Text from '@components/Text/Text';
import {
  ButtonProps as MuiButtonProps,
  ButtonPropsColorOverrides,
  ButtonPropsVariantOverrides,
} from '@mui/material';
import React from 'react';
import { OverridableStringUnion } from '@mui/types';
import { StyledButton } from './button.styles';
import { ColorTypes } from '@customTypes/colors';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary';

export interface ButtonProps extends MuiButtonProps {
  variant?: OverridableStringUnion<ButtonVariant, ButtonPropsVariantOverrides>;
  color?: OverridableStringUnion<ColorTypes, ButtonPropsColorOverrides>;
}

const Button: React.FC<ButtonProps> = ({
  children,
  color = 'primary',
  variant = 'primary',
  style,
  ...props
}) => {
  return (
    <StyledButton
      style={{ textTransform: 'none', ...style }}
      color={color}
      variant={variant}
      {...props}
    >
      <Text variant='h6' fontWeight='fontWeightSemiBold'>
        {children}
      </Text>
    </StyledButton>
  );
};

export default Button;
